<template>
<div class="content">
  <div class="header">
    <el-button type="danger" size="mini" @click="delHouseIds()">批量移除</el-button>
<!--    <el-select size="mini" placeholder="催缴类型" clearable v-model="where2.urge_type">-->
<!--      <el-option :value="1" label="自催"></el-option>-->
<!--      <el-option :value="2" label="诉讼"></el-option>-->
<!--      <el-option :value="3" label="第三方（审核成功）"></el-option>-->
<!--    </el-select>-->
    <el-select size="mini" placeholder="账龄类型" clearable v-model="where2.age">
      <el-option :value="1" label="当期"></el-option>
      <el-option :value="2" label="纯2023"></el-option>
      <el-option :value="3" label="1年以上2年以内"></el-option>
      <el-option :value="4" label="2年以上"></el-option>
    </el-select>
<!--    <el-date-picker-->
<!--      style="width: 120px"-->
<!--      v-model="where2.jh_time"-->
<!--      size="mini"-->
<!--      type="month"-->
<!--      format="yyyy-MM"-->
<!--      value-format="yyyy-MM" placeholder="计划催费月份">-->
<!--    </el-date-picker>-->
    <el-date-picker
      style="width: 120px"
      v-model="where2.qf_time"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="欠费月份">
    </el-date-picker>
    <el-date-picker
      style="width: 120px"
      v-model="where2.last_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="上次缴费月份">
    </el-date-picker>
<!--    <el-select size="mini" placeholder="催费次数" clearable v-model="where2.type">-->
<!--      <el-option :value="0" label="暂未催费"></el-option>-->
<!--      <el-option :value="1" label="1次催费"></el-option>-->
<!--      <el-option :value="2" label="2次催费"></el-option>-->
<!--      <el-option :value="3" label="3次催费"></el-option>-->
<!--      <el-option :value="4" label="多次催费"></el-option>-->
<!--    </el-select>-->
    <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
    <el-button size="mini" @click="exportExcel(1)">导出房产（所有房产）</el-button>
<!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>
  </div>
  <div class="header-tip">
    催费项目数：{{pageData.project_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;催费房产数：{{pageData.total}}
  </div>
  <div class="body">
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border class="table-wrap-table" height="60vh" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" fixed></el-table-column>
          <el-table-column
            prop="house_name"
            label="房产信息" width="320" fixed></el-table-column>
          <el-table-column
            prop="area_name"
            label="区域"
            width="90">
          </el-table-column>
          <el-table-column
            prop="owner_name"
            label="业主姓名"
            width="220">
          </el-table-column>
          <el-table-column
            prop="owner_phone"
            label="业主电话"
            width="150">
          </el-table-column>
          <el-table-column
            prop="bank_account"
            label="银行划扣"
            width="90">
          </el-table-column>
          <el-table-column
            prop="debt_start_month"
            label="欠费起始月份"
            width="120">
          </el-table-column>
          <el-table-column
            prop="debt_month"
            label="欠费月数"
            width="100">
          </el-table-column>

          <el-table-column
            label-class-name="label-column-edit"
            prop="debt_amount"
            label="欠费金额/诉讼金额"
            width="140">
            <template slot-scope="scope">
              <el-link v-if="scope.row.urge_type!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row.debt_amount }}</el-link>
              <span v-if="scope.row.urge_type==='诉讼'">{{scope.row.debt_amount}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="plan_urge_month"
            label="计划催缴月份"
            width="100">
            <template slot-scope="scope">
              <el-date-picker
                style="width: 120px"
                v-model="scope.row.plan_urge_month"
                size="mini"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM" placeholder="欠费月份">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="urge_type"
            label="催缴类型"
            width="90">
            <template slot-scope="scope">
              <el-select size="mini" placeholder="催缴类型" clearable v-model="scope.row.urge_type">
                <el-option value="" label="--"></el-option>
                <el-option value="自催" label="自催"></el-option>
                <el-option value="诉讼" label="诉讼"></el-option>
                <el-option value="第三方" label="第三方"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="第三方合作单位"
            label="第三方合作单位"
            width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row['第三方合作单位']" clearable placeholder="请输入第三方合作单位"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="debt_type"
            label="欠费类型"
            width="150">
            <template slot-scope="scope">
              <el-select size="mini" placeholder="欠费类型" clearable v-model="scope.row.debt_type">
                <el-option :value="1" label="物业"></el-option>
                <el-option :value="2" label="水电"></el-option>
                <el-option :value="3" label="房租"></el-option>
                <el-option :value="4" label="电费"></el-option>
                <el-option :value="5" label="其他"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="debt_reason"
            label="欠费原因"
            width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.debt_reason" clearable placeholder="请输入欠费原因"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="owner_demand"
            label="业主诉求"
            width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.owner_demand" clearable placeholder="请输入业主诉求"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="label-column-edit"
            prop="solution"
            label="解决措施"
            width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.solution" clearable placeholder="请输入解决措施"></el-input>
            </template>
          </el-table-column>

          <el-table-column
            prop="debt_age_type"
            label="账龄类型"
            width="90">
          </el-table-column>

          <el-table-column
            prop="payment_type"
            label="缴费类型"
            width="90">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="上次缴费时间"-->
<!--            label="上次缴费时间"-->
<!--            width="170">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="last_payment_time"
            label="上次缴费时间"
            width="170"></el-table-column>
          <el-table-column
            prop="first_urge_time"
            label="第一次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="second_urge_time"
            label="第二次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="third_urge_time"
            label="第三次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            label="操作"
            width="100" fixed="right">
            <template slot-scope="scope">
<!--              <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>-->
<!--              <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;-->
              <el-button type="danger" size="mini" @click="delHouse(scope.row)">移除</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
          <el-button @click="editTypeSubmit">修 改</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="欠费明细" :visible.sync="dialogVisible_1" :close-on-click-modal="false" width="80vw">

      <div class="view-file-win">
        <el-table
          v-loading="loading" :data="house_bill_order" height="60vh"
          border
          style="width: 100%">
          <el-table-column
            prop="h_name_date"
            label="房产信息" width="360" fixed></el-table-column>
          <el-table-column
            prop="charge_name"
            label="费项"
            width="150">
          </el-table-column>
          <el-table-column
            prop="BillDate"
            label="收费周期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="charge"
            label="金额"
            width="100">
          </el-table-column>
          <el-table-column
            prop="h_name"
            label="业主">
          </el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_1=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
</div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import ViewFile from "../../../Common/ViewFile";
import Track from "../../../../../assets/js/trackHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "LegalHousePlanTemp",
  components: {ViewFlow, ViewFile},
  inject:['where','reginWhere'],
  data(){
    return{
      where2:{
        urge_type:"",
        age:"",
        type:"",
        qf_time:"",
        jh_time:"",
        last_month:"",
        house_name:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      house_bill_order:[],
      dialogVisible_1:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.urge_type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.last_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  computed:{
    ids(){
      return this.multipleSelection.map(ret=>ret.ids)
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("HouseUrgeTempLog/index",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      if(type===2){
        where={
          ...where,
          ...that.where2,
          area_id:that.reginWhere.area_id
        }
      }
      //type===1?"admin/Legal/getLegalHouseExcel2":"admin/Legal/getLegalHouseExcel"
      ButlerHttp.post(type===1?"Legal/getLegalHouseExcel2":"Legal/getLegalHouseExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseToFlow", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            let timeStr = new Date().getTime();
            ERP.navigateTo(`/flow/FlowView?sheet_id=140&master_id=114&timeValue=${timeStr}&batch_number=${res.data}`);
            // that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("Legal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getHouseBill(item){
      const that=this;
      ERP.showLoading()
      ButlerHttp.post("Legal/getHouseBill", {
        projectId: item.project_id,
        houseId: item.house_id
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          that.dialogVisible_1 = true;
          that.house_bill_order = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item.project_id,
        houseId: item.house_id,
        last_time: item.last_payment_time
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      ButlerHttp.post("HouseUrgeTempLog/delete",{
        id:item.id
      }, res => {
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ids.length){
        that.$message.error('请勾选房产！');
        return false
      }
      ButlerHttp.post("HouseUrgeTempLog/deleteBatch",{
        ids:that.ids.join(','),
        project_id:that.reginWhere.project_name
      }, res => {
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .body{
    .table-wrap{
      .table-wrap-table{
        width: 100%;

      }
    }
  }

}

/deep/ .el-table th.el-table__cell.is-leaf{
  padding: 0;
  margin: 0;
  .label-column-edit{
    background-color: #f56c6c;
    color: #FFFFFF;
    cursor: pointer;
    padding: 8px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHousePlanTemp.vue